import React, { useState } from 'react';
import Marker from 'react-google-maps/lib/components/Marker';
import InfoWindow from 'react-google-maps/lib/components/InfoWindow';

const CompanyMarkerWithInfoWindow: React.FC<{ company: ICompany }> = ({ company }) => {
  const [infoWindowIsOpen, setInfoWindowIsOpen] = useState(false);
  const showInfoWindow = () => {
    setInfoWindowIsOpen(!infoWindowIsOpen);
  };

  return (
    <Marker
      key={company.name}
      title={company.name}
      label={{ text: company.name, color: '#fff', className: 'mt-0' }}
      position={{ lat: company.latitude, lng: company.longitude }}
      animation={window.google.maps.Animation.DROP}
      icon="https://cdn.mapmarker.io/api/v1/pin?size=40&background=%23F44E3B&icon=fa-circle&color=%234D4D4D&voffset=0&hoffset=0&"
      onClick={showInfoWindow}
    >
      {infoWindowIsOpen && (
        <InfoWindow key={company.id + '-info-window'} onCloseClick={showInfoWindow}>
          <div
            style={{
              display: 'flex',
              flexDirection: 'column',
              marginLeft: 'auto',
              marginRight: 'auto',
              width: '100%',
            }}
          >
            <h1
              style={{
                fontSize: '18px',
                fontWeight: 'bold',
                height: 'fit-content',
                textAlign: 'center',
              }}
            >
              {company.name}
            </h1>
            <div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                }}
              >
                <h2 style={{ padding: '5%', fontSize: '16px', fontWeight: 'bold', margin: 'auto' }}>
                  Company Info
                </h2>
                <span style={{ wordBreak: 'break-word' }}>
                  <b>{'Address: '}</b>
                  {company.address}
                </span>
                <span style={{ wordBreak: 'break-word' }}>
                  <b>{'Zip Code: '}</b>
                  {company.zip_code}
                </span>
                <span style={{ wordBreak: 'break-word' }}>
                  <b>{'City: '}</b>
                  {company.city}
                </span>
              </div>
              <div
                style={{
                  display: 'flex',
                  flexDirection: 'column',
                  width: '100%',
                }}
              >
                <h2 style={{ padding: '5%', fontSize: '16px', fontWeight: 'bold', margin: 'auto' }}>
                  Company contact
                </h2>
                <span style={{ wordBreak: 'break-word' }}>
                  <b>{'Phone: '}</b>
                  {company?.main_account?.main_user.phone}
                </span>
                <span style={{ wordBreak: 'break-word' }}>
                  <b>{'Mail: '}</b>
                  {company?.main_account?.main_user.mail}
                </span>
              </div>
            </div>
          </div>
        </InfoWindow>
      )}
    </Marker>
  );
};

export default CompanyMarkerWithInfoWindow;
